<template>
  <div id="view-port-debug" v-if="isDebug">
    {{width}}x{{height}}
  </div>
</template>

<script>
export default {
  name: 'ViewPortDebug',
  created() {
    this.addEventListener();
  },
  computed: {
    isDebug() {
      return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging';
    },
  },
  data() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  },
  methods: {
    addEventListener() {
      const self = this;
      window.addEventListener('resize', () => {
        self.width = window.innerWidth;
        self.height = window.innerHeight;
      });
    },
  },
};
</script>

<style scoped lang="scss">
  #view-port-debug {
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
    color: white;
    font-size: 4vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/commons/ViewPortDebug.vue